export const UserTypeEnum = {
  ISAFE: "ISAFE",
  NONISAFE: "NONISAFE",
};

export const ModalTypeEnum = {
  DETAIL: "DETAIL",
  UPDATE: "UPDATE",
  CREATE: "CREATE",
  DELETE: "DELETE",
  VALID: "VALID",
};

export const ROMStatusTypeEnum = {
  VALID: "Valid",
  NOT_VALID: "Tidak Valid",
  UN_REVIEW: "Belum Divalidasi",
  BREAKDOWN: "Breakdown Hauler",
};

export const RoleTypeEnum = {
  ADMIN: 1,
  VIEWER: 2,
};
